import React, { useEffect, useState } from 'react';
import { Alert, Button, Drawer, Spin } from 'antd';
import { m2mErrorMessage, readM2MReport, type M2MContext } from './m2mApi';
import { buildM2MReportDocument } from './m2mReportDocument';
import './M2MReportViewer.css';

interface Props extends M2MContext { handoffId: string; onClose: () => void }

const M2MReportViewer: React.FC<Props> = ({ apiBase, userId, bookId, handoffId, onClose }) => {
  const [html, setHtml] = useState<string>();
  const [error, setError] = useState<string>();
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    const returnFocus = document.activeElement as HTMLElement | null;
    setHtml(undefined);
    setError(undefined);
    readM2MReport({ apiBase, userId, bookId }, handoffId, controller.signal)
      .then(value => { if (!controller.signal.aborted) setHtml(buildM2MReportDocument(value)); })
      .catch(reason => {
        if (!controller.signal.aborted) setError(m2mErrorMessage(reason, 'Unable to load this report. Please try again.'));
      });
    return () => { controller.abort(); returnFocus?.focus(); };
  }, [apiBase, userId, bookId, handoffId, attempt]);

  return <Drawer title="Deep Dive report" open onClose={onClose} width="min(1100px, 100vw)" className="m2m-report-viewer" destroyOnClose>
    {error ? <Alert type="error" showIcon message={error} action={<Button onClick={() => setAttempt(value => value + 1)}>Retry</Button>} />
      : html === undefined ? <Spin tip="Loading report…" />
        : <iframe title="Deep Dive report content" srcDoc={html}
            sandbox="allow-popups allow-popups-to-escape-sandbox" referrerPolicy="no-referrer" />}
  </Drawer>;
};

export default M2MReportViewer;
